import { Text } from '@chakra-ui/react';
import React from 'react';

export const SectionHeader = ({ children }: { children: React.ReactNode }) => {
	return (
		<Text
			fontWeight="600"
			fontSize="16px"
			lineHeight={{ base: '15px', hashup: '20px' }}
			letterSpacing=".1em"
			textTransform="uppercase"
		>
			{children}
		</Text>
	);
};
